import { useEffect } from "react";
import useResizeObserver from './useResizeObserver';

function useElementOnScreen() {
  const [refToolbarResize, bounds] = useResizeObserver();

  useEffect(() => {
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const scrollY = (window.pageYOffset || document.documentElement.scrollTop);
    const scrollX = (window.pageXOffset || document.documentElement.scrollLeft);

    if (bounds.y + bounds.height > windowHeight) {
      window.scrollTo({
        left: scrollX,
        top: bounds.y + bounds.height + scrollY - windowHeight + 18,
        behavior: 'smooth',
      })
    }
  }, [bounds]);

  return refToolbarResize;
}

export default useElementOnScreen;
